export const NEWUSER = "new";
export const EDITUSER = "edit";

export const ALLFITLERS = "all";
